import { Button, Grid, TextField } from '@mui/material';
import React from 'react';

import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { resetPassword } from '../../services/auth';

function ResetPasswordPage() {
	const navigate = useNavigate();
	const [search, setSearch] = useSearchParams();
	const [registrationType, setRegistrationType] = React.useState('');
	const [accessToken, setAccessToken] = React.useState('');

	const [newPassword, setNewPassword] = React.useState('');
	const [confirmNewPassword, setConfirmNewPassword] = React.useState('');
	const [passwordResetComplete, setPasswordResetComplete] =
		React.useState(false);

    const validateParams = (type, token) => {
      if ((type === 'phone' || type === 'email') && token?.length > 0) {
        return true;
      }
      return false;
    };

  	const onSubmit = async () => {
      if (newPassword.length === 0) {
        toast.error('Password has zero characters', {
          timeOut: 1000,
        });
        return;
      }
      if (newPassword !== confirmNewPassword) {
        toast.error('Passwords do not match', {
          timeOut: 1000,
        });
        return;
      }
      try {
        let response = await resetPassword(
          accessToken,
          newPassword,
          registrationType
        );
        if (response.errors) {
          toast.error(
            'There was an error in resetting password. Please try after sometime.',
            {
              timeOut: 1000,
            }
          );
          return;
        }
        setPasswordResetComplete(true);
      } catch (error) {
        console.error('error in resetting password', error);
        toast.error(
          'There was an error in resetting password. Please try after sometime.',
          {
            timeOut: 1000,
          }
        );
      }
    };

    React.useEffect(() => {
      let type = search.get('type')?.toLowerCase();
      let accessToken = search.get('token');
      if (validateParams(type, accessToken)) {
        setRegistrationType(type);
        setAccessToken(accessToken);
      } else {
        navigate('/login');
      }
    }, []);

  return (
    <div className="p-5 bg-light rounded-3">
      <div className="contiainer-fluid py-5">
        <ToastContainer />
        <div className="flex flex-col items-center mb-2">
          <h1 className="text-2xl font-bold">RESET PASSWORD</h1>
        </div>
        <Grid container style={{ width: 400 }}>
          {!passwordResetComplete ? (
            <>
              <Grid item xs={12} style={{ margin: 5 }}>
                <input
                  className={`input border-1 border-gray-200 input-primary bg-white focus:outline-none focus:border-1 w-full`}
                  label={"Password"}
                  name={"password"}
                  fullWidth
                  type="password"
                  value={newPassword}
                  placeholder={"Enter new Password"}
                  onChange={(event) => setNewPassword(event.target.value)}
                />
              </Grid>
              <Grid item xs={12} style={{ margin: 5 }}>
                <input
                  className={`input border-1 border-gray-200 input-primary bg-white focus:outline-none focus:border-1 w-full`}
                  label={"Confirm Password"}
                  name={"confirm-password"}
                  fullWidth
                  type="password"
                  value={confirmNewPassword}
                  placeholder={"Enter new Password"}
                  onChange={(event) =>
                    setConfirmNewPassword(event.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12} style={{ margin: 5 }}>
                <button
                  className="btn btn-primary text-white font-bold w-full rounded-md mt-2"
                  type="submit"
                  variant="contained"
                  onClick={onSubmit}
                >
                  Submit
                </button>
              </Grid>
            </>
          ) : (
            <Grid item xs={12} style={{ margin: 5 }}>
              <p>
                Password Reset Complete. Please head to{" "}
                <Link
                  to={"/login"}
                  style={{
                    color: "blue",
                    border: "inherit",
                    textDecoration: "none",
                  }}
                >
                  {"Login"}
                </Link>{" "}
                page and access your account with new credentials.
              </p>
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
